import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Icon } from '..';
import { Typography } from 'antd';

const CloseButton = ({ onClick }) => {
  return (
    <Icon
      className="h-6 w-6 cursor-pointer text-primary-active"
      data-cy="close-button"
      name="close"
      onClick={onClick}
    />
  );
};

CloseButton.propTypes = {
  onClick: PropTypes.func,
};

const Header = ({ title, noCloseButton, onClose }) => {
  const theme = 'bg-primary-400';
  const flex = 'flex items-center justify-between';
  const border = '';
  const spacing = 'p-4';

  return (
    <div className={classNames(theme, flex, border, spacing)}>
      <Typography.Title className="mb-0 text-xl text-white" level={3}>
        {title}
      </Typography.Title>
      {!noCloseButton && <CloseButton onClick={onClose} />}
    </div>
  );
};

Header.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  noCloseButton: PropTypes.bool,
  onClose: PropTypes.func,
};

Header.defaultProps = {
  noCloseButton: false,
};

export default Header;
